import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled, { css } from 'styled-components'
import Loading from './components/Loading'
import { H1 } from './styles/text'
import { ReactComponent as Flip } from './svg/flip.svg'
import { withOrientationChange } from 'react-device-detect'

const Home = lazy(() => import('./pages/Home'))
const Choose = lazy(() => import('./pages/Choose'))
const Confirm = lazy(() => import('./pages/Confirm'))
const Capture = lazy(() => import('./pages/Capture'))
const Edit = lazy(() => import('./pages/Edit'))
const Submit = lazy(() => import('./pages/Submit'))
const Success = lazy(() => import('./pages/Success'))

const App: React.FC<{ isLandscape: boolean }> = ({ isLandscape }) => {
  return (
    <>
      <Suspense fallback={<Loading suspense />}>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/choose">
            <Choose />
          </Route>
          <Route exact path="/choose/:index">
            <Confirm />
          </Route>
          <Route exact path="/choose/:index/capture">
            <Capture />
          </Route>
          <Route exact path="/choose/:index/capture/edit">
            <Edit />
          </Route>
          <Route exact path="/choose/:index/submit">
            <Submit />
          </Route>
          <Route exact path="/success">
            <Success />
          </Route>
        </Switch>
      </Suspense>
      {isLandscape && window.innerWidth <= 767 * window.devicePixelRatio && window.innerHeight < window.innerWidth && (
        <RotateModal>
          <RotateContent>
            <Flip />
            <H1
              css={css`
                margin-top: 20px;
                color: rgb(118, 118, 118);
                max-width: 225px;
                font-weight: normal;
              `}
            >
              For an optimal mobile experience, please rotate and hold your device vertically.
            </H1>
          </RotateContent>
        </RotateModal>
      )}
    </>
  )
}

const RotateModal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  touch-action: none;
`

const RotateContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: white;
  border-radius: 5px;
  box-shadow: -5px 5px 15px 10px rgba(109, 80, 80, 0.2);
`

export default withOrientationChange(App)
